import React from "react";
import {
  Container,
  Grid,
  Typography,
  Step,
  Stepper,
  StepLabel,
} from "@material-ui/core";
import CarbonCreditsWidget from "../shared/carbonCreditsWidget/CarbonCreditsWidget";
import User from "../shared/user/user";
import Footer from "../footer/Footer";
import {
  useStyles,
  DashboardLogic,
  DashboardService,
} from "./dashboard.module";
import VerifiedProjects from "../verifiedProjects/verifiedProjects";
import EgreenCoinsSoon from "../egreenCoinsSoon/egreenCoinsSoon";

const Dashboard = (props) => {
  const classes = useStyles();

  const service = DashboardService();
  const {
    values,
    translator,
    operations,
    nfts,
    sbts,
    goToProjects,
  } = DashboardLogic(
    service.getUser,
    service.getHistoryOfOperations,
    service.getHistoryOfOffers,
    service.getHistoryOfNFTs,
    props
  );
  const steps = [
    translator("carbonCredits.subtitle1"),
    translator("carbonCredits.subtitle2"),
    translator("carbonCredits.subtitle3"),
  ];
  const NFTInfoText = translator("carbonCreditsWidget.availableDescription");
  const SBTInfoText = translator("carbonCreditsWidget.usedDescription");
  return (
    <div className={classes.dashboardStyle}>
      <Container>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <User user={values.user} />
          </Grid>
        </Grid>
      </Container>

      <Grid container className={classes.containerCabonCredits}>
        <Grid item lg={1} md={1} sm={1} xs={1}></Grid>
        <Grid item lg={10} md={10} sm={10} xs={10}>
          <Grid container spacing={3} className={classes.rootCabonCredits}>
            <Grid item lg={7} md={7} sm={7} xs={12}>
              <Typography className={classes.carbonCreditsTitle}>
                {translator("carbonCredits.title1")}
              </Typography>
            </Grid>
            <Grid item lg={5} md={5} sm={5} xs={12}>
              <Stepper orientation="vertical" className={classes.timeline}>
                {steps.map((label, index) => (
                  <Step key={label} className={classes.stepDashboard}>
                    <StepLabel>
                      <Typography className={classes.subtitleCabonCredits}>
                        {label}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={1} md={1} sm={1} xs={1}></Grid>
      </Grid>

      <Container>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CarbonCreditsWidget
              user={values.user}
              operations={operations}
              goToProjects={goToProjects}
              nfts={nfts}
              sbts={sbts}
              nftTooltip={NFTInfoText}
              sbtTooltip={SBTInfoText}
            />
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          // spacing={3}
          className={classes.coinSoon}
        >
          <EgreenCoinsSoon className={classes.coinSoonBanner} />
        </Grid>
        <Grid item lg={12} sm={12} xs={12} className={classes.contentDashboard}>
          <VerifiedProjects />
        </Grid>
      </Container>
      <Footer />
    </div>
  );
};
export default Dashboard;
